import Header from '../components/Header';
import Hero from '../components/Hero';
import ServiceCards from '../components/ServiceCards';
import About from '../components/About';
import ServicesDetail from '../components/ServicesDetail';
import CtaBanner from '../components/CtaBanner';
import InstructionsSection from '../components/InstructionsSection';
import Troubleshooting from '../components/Troubleshooting';
import FinalCta from '../components/FinalCta';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <div className="home-page">
      <Header />
      <main>
        <Hero />
        <ServiceCards />
        <About />
        <ServicesDetail />
        <CtaBanner />
        <InstructionsSection />
        <Troubleshooting />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
